const SCOPE = 'disclosure-delivery';

export const DisclosureDeliveryTestIds = {
  ROOT: SCOPE,
  REFRESH_BUTTON: `${SCOPE}.refresh-button`,
  ECD_CHIP: `${SCOPE}.ecd-chip`,
  PACKAGE_STATUS_LABEL: `${SCOPE}.package-status-label`,
  VIEW_DOCUMENTS_BUTTON: `${SCOPE}.view-documents-button`,
  RESEND_PACKAGE_BUTTON: `${SCOPE}.resend-package-button`,
  SIGNER_ACTION_BUTTON: `${SCOPE}.signer-action-button`,
  CANCEL_SENDING_BUTTON: `${SCOPE}.cancel-sending-button`,
  PREVIEW_NOTICE: `${SCOPE}.preview-notice`,
  AUDIT_STRIP: `${SCOPE}.audit-strip`,
  VIEW_AUDIT_TRAIL_BUTTON: `${SCOPE}.view-audit-trail-button`,
  AUDIT_TRAIL_DIALOG: `${SCOPE}.audit-trail-dialog`,
  CANCEL_BUNDLE_CONFIRM_BUTTON: `${SCOPE}.cancel-bundle-confirm-button`,
  FIX_EMAIL_INPUT: `${SCOPE}.fix-email-input`,
  FIX_EMAIL_CANCEL_BUTTON: `${SCOPE}.fix-email-cancel-button`,
  FIX_EMAIL_SUBMIT_BUTTON: `${SCOPE}.fix-email-submit-button`,
  MARK_MAILED_DATE_INPUT: `${SCOPE}.mark-mailed-date-input`,
  MARK_MAILED_CANCEL_BUTTON: `${SCOPE}.mark-mailed-cancel-button`,
  MARK_MAILED_SUBMIT_BUTTON: `${SCOPE}.mark-mailed-submit-button`,
  RESEND_CANCEL_BUTTON: `${SCOPE}.resend-cancel-button`,
  RESEND_CONFIRM_BUTTON: `${SCOPE}.resend-confirm-button`,
  SWITCH_FACTOR_TYPE_RADIO: `${SCOPE}.switch-factor-type-radio`,
  SWITCH_FACTOR_VALUE_INPUT: `${SCOPE}.switch-factor-value-input`,
  SWITCH_FACTOR_CANCEL_BUTTON: `${SCOPE}.switch-factor-cancel-button`,
  SWITCH_FACTOR_SUBMIT_BUTTON: `${SCOPE}.switch-factor-submit-button`,
  CHANNEL_BADGE: `${SCOPE}.channel-badge`,
  SIGNER_REMEDIATION_ICON: `${SCOPE}.signer-remediation-icon`,
  MAIL_RECEIPT_ACTION: `${SCOPE}.mail-receipt-action`,
  EDIT_DATES_ACTION: `${SCOPE}.edit-dates-action`,
  EDIT_DATES_CANCEL_BUTTON: `${SCOPE}.edit-dates-cancel-button`,
  EDIT_DATES_SUBMIT_BUTTON: `${SCOPE}.edit-dates-submit-button`,
  getPackageHeaderId: id => `${SCOPE}.package-${id}.header`,
  getSignerTableId: id => `${SCOPE}.package-${id}.signer-table`,
  getEditDatesSentInputId: id => `${SCOPE}.edit-dates-sent-input-${id}`,
  getEditDatesSignedInputId: id => `${SCOPE}.edit-dates-signed-input-${id}`,
  getRecipientCopyButtonId: id => `${SCOPE}.view-copy-button-${id}`,
  getRecipientPreviewButtonId: id => `${SCOPE}.preview-copy-button-${id}`,
};
